import { Observable } from 'rxjs';

import { ModulePage } from 'module/page/module-page';

export abstract class ModulePageRepositoryPort {
	public abstract observePagesByIds(pagesId: string[]): Observable<ModulePage[]>;

	public abstract saveModulePages(modulePages: ModulePage[]): Promise<void>;
}
